import React, { useRef } from "react";

export default function Header({
  sources, selectedFactionId, onFactionChange, pointsMode, setPointsMode,
  customLimit, setCustomLimit, totals, limit, saveRoster, loadRosterFromFile, exportPdf, clearRoster, user, logout,
}) {
  const fileRef = useRef();

  let stateClass = "";
  if (limit > 0) {
    if (totals.pts > limit) stateClass = " state-over";
    else if (totals.pts >= limit * 0.9) stateClass = " state-warn";
    else stateClass = " state-ok";
  }

  return (
    <header className="hdr">
      <div className="hdr-inner">
        <div className="hdr-row-top">
        <div className="brand">
          <span className="brand-mark">NC</span>
          <div>
            <div className="brand-name">NORTHAG / CENTAG</div>
            <div className="brand-sub">BATTLEGROUP LIST BUILDER</div>
          </div>
        </div>

        <div className="hdr-field">
          <label htmlFor="factionSelect">Choose Army:</label>
          <select
            id="factionSelect"
            className="hdr-select"
            value={selectedFactionId}
            onChange={(e) => onFactionChange(e.target.value)}
            data-testid="faction-select"
          >
            {sources.map((s) => (
              <option key={s.id} value={s.id}>{s.supplement ? `${s.name} (${s.supplement})` : s.name}</option>
            ))}
          </select>
        </div>

        <div className="hdr-field">
          <label htmlFor="pointsMode">Army size</label>
          {pointsMode === "custom" ? (
            <input
              id="customLimit"
              className="hdr-input"
              type="number"
              min="50"
              step="5"
              autoFocus
              value={customLimit}
              onChange={(e) => setCustomLimit(Number(e.target.value) || 0)}
              onKeyDown={(e) => { if (e.key === "Escape") setPointsMode("750"); }}
              title="Enter custom points (press Esc to return to presets)"
              data-testid="custom-limit-input"
            />
          ) : (
            <select
              id="pointsMode"
              className="hdr-select"
              value={pointsMode}
              onChange={(e) => setPointsMode(e.target.value)}
              data-testid="points-mode-select"
            >
              <option value="500">500 pts</option>
              <option value="750">750 pts</option>
              <option value="1000">1000 pts</option>
              <option value="custom">Custom</option>
            </select>
          )}
        </div>

        <div className={"readout" + stateClass} id="pointsReadout" data-testid="points-readout">
          <label>Points</label>
          <div className="value">
            <span data-testid="points-used">{totals.pts}</span>
            <small> / <span data-testid="points-limit">{limit || "\u2014"}</span></small>
          </div>
        </div>

        <div className="readout readout-br">
          <label>BR:</label>
          <div className="value" id="brValue" data-testid="br-value">{totals.br}</div>
        </div>
          <div className="hdr-right">
          {user ? <span className="user-email" data-testid="user-email" title={user.email || ""}>{user.email}</span> : null}

        <div className="hdr-actions">
          <button className="btn btn-clear" onClick={clearRoster} title="Clear all units from the roster" data-testid="clear-roster-btn">🗑 Clear Roster</button>
          <button className="btn" onClick={saveRoster} title="Save army list to a JSON file" data-testid="save-btn">⬇ Save</button>
          <button className="btn" onClick={() => fileRef.current.click()} title="Load a previously saved army list" data-testid="load-btn">⬆ Load</button>
          <input
            type="file"
            ref={fileRef}
            accept="application/json"
            className="visually-hidden"
            onChange={(e) => { if (e.target.files[0]) loadRosterFromFile(e.target.files[0]); e.target.value = ""; }}
            data-testid="file-input"
          />
          <button className="btn btn-primary" onClick={exportPdf} title="Export a printable roster" data-testid="export-pdf-btn">🖶 Export PDF</button>
          <button className="btn btn-logout" onClick={logout} title={user ? `Signed in as ${user.email || "user"} — click to log out` : "Log out"} data-testid="logout-btn">⎋ Log Out</button>
        </div>
          </div>
        </div>
      </div>
    </header>
  );
}
